import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { differenceInSeconds } from 'date-fns/differenceInSeconds';
import LiveReserveTimeoutOverlay from '@ecosystems/events/reserve/LiveReserveTimeoutOverlay';
import MessageStripe from '@components/MessageStripe';
import { Flex } from '@components/layout/Grid';

const getMinutesLeft = visitDate => {
  return Math.max(
    600 - differenceInSeconds(new Date(), new Date(visitDate)),
    0
  );
};

const normalizeNumber = number => {
  return number.toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  });
};

const Overlay = () => {
  if (typeof window === 'undefined') {
    return null;
  }

  return ReactDOM.createPortal(
    <LiveReserveTimeoutOverlay />,
    document.getElementById('__next')
  );
};

const CountDownBanner = styled(MessageStripe)`
  position: fixed;
  top: 0;

  @media (min-width: ${({ theme }) => theme.viewports.laptop}px) {
    position: static;
  }
`;

export const ReserveCountdown = ({ visitDate }) => {
  const [countdown, setCountdown] = useState(getMinutesLeft(visitDate));

  useEffect(() => {
    const intervalID = setInterval(() => {
      const minutesLeft = getMinutesLeft(visitDate);
      setCountdown(minutesLeft);

      if (minutesLeft === 0) {
        clearInterval(intervalID);
      }
    }, 1000);

    return () => {
      clearInterval(intervalID);
    };
  }, []);

  return (
    <Flex width={1}>
      {countdown === 0 ? <Overlay /> : null}
      <CountDownBanner bg="#F0F5FB" color="#242424" closable={false}>
        <Trans
          id="live.payment_page.countdown_banner"
          values={{
            min: normalizeNumber(Math.floor(countdown / 60)),
            sec: normalizeNumber(countdown % 60),
          }}
          components={[<b key="0"></b>]}
        />
      </CountDownBanner>
    </Flex>
  );
};
